import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService, LoggerService, SecurityService } from 'saker-core';
import { NoteDTO } from '../Protocol/note.dto';
import { catchError } from 'rxjs';
import { AuditSimpleLinkDTO } from '../Protocol/auditSimpleLink.dto';

@Injectable({
  providedIn: 'root'
})
export class NoteService {

  constructor(
    private configuration: ConfigurationService,
    private http: HttpClient,
    private logger: LoggerService,
    private security: SecurityService
  ) { }


  // function reject(response) {
  //     if (response && response.data) {
  //         if (response.data.Message) {
  //             return $q.reject(response.data.Message);
  //         }
  //         else {
  //             return $q.reject(response.data);
  //         }
  //     }
  //     else {
  //         return $q.reject('Service Unavailable');
  //     }
  // }

  saveNote(data:any) {
      let id = data.noteId ? data.noteId : 0;
      data.noteDate = new Date(new Date(data.noteDate).setHours(1));
      let url = this.configuration.CONFIG.BASE_URL + "/dsm/notes/note/" + id;

      return this.http.post<string>(url, data, { withCredentials: true }).pipe(
        catchError(error => this.logger.handleError(error)));

  }

  // function getNotes() {
  //     let url = sakerConfig.BASE_URL + '/dsm/notes';
  //     let config = {
  //         withCredentials: true
  //     };

  //     return $http.get(url, config)
  //         .then(getData)
  //         .catch(reject);
  // }

  getAuditTimeline(id:string) {
      let url = this.configuration.CONFIG.BASE_URL + '/dsm/audit/timeline/' + id;

      return this.http.get<AuditSimpleLinkDTO[]>(url, { withCredentials: true }).pipe(
        catchError(error => this.logger.handleError(error)));
  }

  getNote(id:string) {
      let url = this.configuration.CONFIG.BASE_URL + "/dsm/notes/note/" + id;

      return this.http.get<NoteDTO>(url, { withCredentials: true }).pipe(
        catchError(error => this.logger.handleError(error)));
  }

  // function deleteNote(id) {
  //     let url = sakerConfig.BASE_URL + "/dsm/notes/note/" + id;
  //     let config = {
  //         withCredentials: true,
  //     };

  //     return $http.delete(url, config)
  //         .then(getData)
  //         .catch(reject);
  // }

  // function removeFromAttachments(id, itemId) {
  //     let url = sakerConfig.BASE_URL + "/dsm/notes/note/" + id + "/Attachments/" + itemId;
  //     let config = {
  //         withCredentials: true,
  //     };

  //     return $http.delete(url, config)
  //         .then(getData)
  //         .catch(reject);
  // }

}
